module.exports = __webpack_public_path__ + "media/images/admin/icons/rotate-ccw-4888cf3bdf1664560318c6caf43d01ba.svg";